import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { projectKey } from 'shared/constants'
import { usePoll } from 'shared/hooks/usePoll'

import { getNewGames } from 'features/slots/actions'

const NewGamesPolling: React.FC = () => {
  const dispatch = useDispatch()

  const handleGetNewGames = useCallback(async () => {
    dispatch(getNewGames(projectKey))
  }, [dispatch])

  usePoll(handleGetNewGames, { delay: 3 * 60 })

  return null
}

export default NewGamesPolling
